import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';
import DealerLoginForm from './DealerLoginForm';

const DealerLogin = observer((): JSX.Element => {
  const { dealerLoginStore } = useStores();

  return (
    <DealerLoginForm
      isSubmitting={dealerLoginStore.submitting}
      handleSubmit={dealerLoginStore.handleLogin}
      credentials={dealerLoginStore.dealerLoginCredentials}
    />
  );
});

export default DealerLogin;
